@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.USERS.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !user) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.USERS.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout>
    <app-form-user
      [payload]="user"
      [showIntro]="false"
      [showPersonalSectionHeader]="false"
      [showEmployeeSection]="false"
      [showCompensationSection]="false"
      [exclude]="['password', 'email']"
      [onUpdate]="reload"
    ></app-form-user>
  </app-admin-form-layout>
}
